






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { RouteRecord } from 'vue-router';
import { Apps } from '@/constants/apps';
import { IS_MOBILE } from '@/helpers/browser';

const {
  VUE_APP_HOMESCAPES_LINK_TO_APP: HOMESCAPES_LINK_TO_APP,
  VUE_APP_TOWNSHIP_LINK_TO_APP: TOWNSHIP_LINK_TO_APP,
} = process.env;

@Component
export default class PlayButton extends Vue {
  @Prop({ type: [String, Object], required: true })
  readonly to!: string | RouteRecord;

  linkToApp = this.$appName === Apps.Homescapes ? HOMESCAPES_LINK_TO_APP : TOWNSHIP_LINK_TO_APP;

  isMobile: boolean = IS_MOBILE;

  handleClick(event: PointerEvent, navigate: (ev: PointerEvent) => void): void {
    navigate(event);

    this.$emit('click');
  }
}
